export default {
  name: 'review',
  computed: {
    env () {
      return this.$store.getters.env
    },
    smartthonUrl () {
      return `${this.env.DOMAIN}/preview/${this.$route.params.enterpriseId}/${this.$route.params.smartthonId}`
    },
    isSignedIn () {
      return this.$store.getters.isSignedIn
    }
  },
  data () {
    return {
      title: '',
      cnt: '',
      todo: [],
      new_cnt: 0,
      grading: [],
      grading_cnt: 0,
      done: [],
      done_cnt: 0,
      prize: [],
      prize_cnt: 0,
      loading: true
    }
  },
  mounted () {
    let pathParams = {
      enterpriseId: this.$route.params.enterpriseId,
      smartthonId: this.$route.params.smartthonId
    }

    this.$apig.get(this.$store.getters.api.SUGGESTION, pathParams, {}, {}, !this.isSignedIn)
      .then(response => {
        this.title = response.data.title
        this.cnt = response.data.cnt
        this.todo = response.data.new
        this.new_cnt = response.data.new.length
        this.grading = response.data.grading
        this.grading_cnt = response.data.grading.length
        this.done = response.data.done
        this.done_cnt = response.data.done.length
        this.prize = response.data.prize
        this.prize_cnt = response.data.prize.length
        this.loading = false
      })
  },
  methods: {
    studentAvatar (item) {
      return `${this.env.S3}/student/avatar/${item.avatarId}.png`
    },
    getIcon (i, score) {
      if (i <= Math.floor(score)) return 'star'
      else if (i > Math.floor(score) && i <= Math.round(score)) return 'star-half-alt'
      else return 'star'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/report/review/review.js